'use strict';

var Arctick = require('./apiClient');
var client = new Arctick({
    apiBaseUrl: process.env.BASE_URL,
    protocol: process.env.PROTOCOL,
    clientId: process.env.CLIENT_ID,
    clientSecret: process.env.CLIENT_SECRET
});
var resources = {
    Accounts: require('./resources/accounts'),
    Items: require('./resources/items'),
    Categories: require('./resources/categories'),
    Users: require('./resources/users'),
    Panels: require('./resources/panels'),
    Purchases: require('./resources/purchases'),
    Addresses: require('./resources/addresses'),
    Orders: require('./resources/orders'),
    Inbox: require('./resources/inbox'),
    CustomFields: require('./resources/customfields'),
    ShippingMethods: require('./resources/shippingMethods'),
    Transactions: require('./resources/transactions'),
    Files: require('./resources/files'),
    Comparisons: require('./resources/comparisons'),
    Carts: require('./resources/carts'),
    Marketplaces: require('./resources/marketplaces'),
    ActivityLog: require('./resources/activitylog'),
    Emails: require('./resources/emails'),
    Payments: require('./resources/payments'),
    Media: require('./resources/media'),
    ContentPages: require('./resources/contentPages'),
    Chat: require('./resources/chat'),
    CustomTables: require('./resources/customTables'),
    Quotations: require('./resources/quotations'),
    Requisitions: require('./resources/requisitions'),
    ReceivingNotes: require('./resources/receivingNotes'),
    Invoices: require('./resources/invoices'),
    Exchange: require('./resources/bepensa/exchangeCurrency'),
    Availability: require('./resources/bepensa/Availability'),
    InvoiceRequest: require('./resources/bepensa/InvoiceRequestTool'),
    Offers: require('../src/public/js/bepensa/offers'),
    Banners: require('../src/public/js/bepensa/banners'),
    OrderAgil: require('../src/public/js/bepensa/orderagil'),   
    Backorders: require('./resources/bepensa/backorders'),
    CreditInformation:  require('../src/public/js/bepensa/credit'),
    CustomSearch: require('./resources/bepensa/search'),
    BepensaPrices: require('../src/public/js/bepensa/prices'),
    Statements: require('./resources/bepensa/Statements'),
    Motors: require('./resources/bepensa/Motors'),
    CPLs: require('./resources/bepensa/CPLs'),
    TraceRecord: require('./resources/bepensa/Traces'),
    OpenPay: require('./resources/bepensa/OpenPay'),
    Arcadier: require('./resources/bepensa/Arcadier'),
    Browser: require('../src/public/js/bepensa/browser'),
};
client._prepResources(resources);

module.exports = client;
